import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from "react-intl";
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
 import { Link } from "react-router-dom";
import {
 
  RectangleSelector
} from 'react-image-annotation/lib/selectors'
import Annotation from 'react-image-annotation'
import { IconButton,Tooltip } from '@material-ui/core';
import clsx from 'clsx';
 import { createTemplateData, getTemplateByKey,getTemplateDataByKey
//  ,getRolesByAccount 
} from "../../crud/auth.crud";
import { Figure } from "react-bootstrap";
import {  format } from 'date-fns';
import PrintIcon from '@material-ui/icons/Print';
import { EditorState,convertToRaw,ContentState } from 'draft-js';
 import { Editor } from 'react-draft-wysiwyg';
 import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import './react-draft-wysiwyg.css';

const useStyles = withStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
   formControl: {
    //margin: theme.spacing(3),
  },
};


class ViewTemplateData extends React.Component {

state = {
    	patient:{},
    	menu: false,
    	annotations: [],
    annotation: {},
    type:'RECTANGLE',
  	}
	
constructor(props)
{
  super(props);
  let template={fieldGroups:[{fields:[{}]}]};
  
  //console.log("patient id");
  //console.log(this.props.location.data);
  if(this.props.location!==undefined && this.props.location!==null && this.props.location.data!==undefined&&  this.props.location.data !== null)
  {
  	this.state = {
      editorState: EditorState.createEmpty(),
     // template:this.props.location.data.template,
      patient: this.props.location.data.patient,
      fromPath: this.props.location.data.fromPath,
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      annotations: [],
    annotation: {},
    type:'RECTANGLE',
    };
  }
  else if(this.props.data!==undefined && this.props.data!==null)
  {
	this.state = {
		editorState: EditorState.createEmpty(),
	   // template:this.props.location.data.template,
		patient: this.props.data.patient,
		fromPath: this.props.data.fromPath,
		status:false,
		statusMessage:'',
		alertType:'alert-success',
		loading:false,
		statusColor:'alert-success',
		annotations: [],
	  annotation: {},
	  type:'RECTANGLE',
	  };
  }
  else
  {
  		this.state = {
      editorState: EditorState.createEmpty(),
      //template:{},
      patient:{},
       status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      annotations: [],
    annotation: {},
    type:'RECTANGLE',
      
    };
  }
 
  
}

onChange = (annotation) => {
    this.setState({ annotation })
  }

  onSubmit = (annotation) => {
    const { geometry, data } = annotation

    this.setState({
      annotation: {},
      annotations: this.state.annotations.concat({
        geometry,
        data: {
          ...data,
          id: Math.random()
        }
      })
    })
  }
async componentDidMount()
  {
  	
    if(this.props.location!==undefined && this.props.location!==null && this.props.location.data!==undefined&&  this.props.location.data !== null)
    {
    	console.log(this.props.location.data.template);
	    await getTemplateByKey(this.props.location.data.template.templateKey).then(response => response.data)
	    .then((data) => {
	      this.setState({ template: data })
	      console.log(data);
	     });
	    await getTemplateDataByKey(this.props.location.data.template.templateDataKey).then(response => response.data)
	    .then((data) => {
	      this.setState({ templateData: data[0] })
	      console.log(data);
	     });

	    let editorState = EditorState.createEmpty();
  		let contentBlock = null;
		console.log("template length:::",this.state.template);
    	this.state.template[0].fieldGroups.map((fg)=>(
  			fg.fields.filter(x=> x.dataType === "wysiwyg").map((f)=>{

  				contentBlock = htmlToDraft(this.state.templateData.formData[f.fieldName]);
			    if (contentBlock) {
			      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			       editorState = EditorState.createWithContent(contentState);
			     this.setState({editorState:editorState});
			    }
			    
			  }
  			)
  		))
    }
	else if(this.props.data!==null && this.props.data!==undefined)
	{
		console.log(this.props.data.template);
	    await getTemplateByKey(this.props.data.template.templateKey).then(response => response.data)
	    .then((data) => {
	      this.setState({ template: data })
	      console.log(data);
	     });
	    await getTemplateDataByKey(this.props.data.template.templateDataKey).then(response => response.data)
	    .then((data) => {
	      this.setState({ templateData: data[0] })
	      console.log(data);
	     });

	    let editorState = EditorState.createEmpty();
  		let contentBlock = null;
		console.log("template length:::",this.state.template);
    	this.state.template[0].fieldGroups.map((fg)=>(
  			fg.fields.filter(x=> x.dataType === "wysiwyg").map((f)=>{

  				contentBlock = htmlToDraft(this.state.templateData.formData[f.fieldName]);
			    if (contentBlock) {
			      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			       editorState = EditorState.createWithContent(contentState);
			     this.setState({editorState:editorState});
			    }
			    
			  }
  			)
  		))
	}
  }

submitForm = event => {
	const {template,patient, ...inputFields } = this.state;
	console.log(inputFields);
	//console.log(template);
	this.state.template.fieldGroups.map((groups) => {
		groups.fields.map((field) => {
			//const node = ReactDOM.findDOMNode(this.refs[field.fieldName]);
			//console.log(field.fieldName+"--"+node);
		})
    
    // do what you want to do with `node`
  })
	
    let formdata = {};
    formdata = inputFields;
    formdata.templateKey = template.templateId;
    formdata.templateName = template.templateName;
    formdata.pEntityKey = patient.pEntityId;
    formdata.patientId = patient.id;
    //formdata.pEntityKey = 
    this.setState({loading:false});
	createTemplateData(patient.id,formdata)
                      .then(resp => {
                        //props.register(accessToken);
                       
                       this.setState({status:true,
                        statusMessage:'New schedule has been created successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                       
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                      

	event.preventDefault();
}

handleChange = event => {
	this.setState({
		[event.currentTarget.name] : event.currentTarget.value
	})
}

	render()
	{
		const patient = this.state.patient;
		if(this.state.templateData!=null)
		{
		console.log("templatedata:::",this.state.templateData.formData);

		}
    	return (
    		<>
    			 {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
    			{this.state.template!=null && this.state.templateData!=null && this.state.template.map((temp)=>(
    				<>
    			<div className="row">
        			<div className="col-xl-12">
        				<div className="kt-portlet kt-portlet--height-fluid">
                			<div className="kt-portlet__body">
                				<div className="row">
                					<div className="col">
                				 		<h5>Name: {patient.firstName + ' ' + patient.lastName}</h5>
                				 	</div>
                				 	<div className="col">
                				 		<h5>DOB: {format(new Date(patient.dateOfBirth), 'MM/dd/yyyy')}</h5>
                				 	</div>
                				 	<div className="col">
                				 		<h5>Mobile: {patient.mobile}</h5>
                				 	</div>
                				 	<div className="col">
                				 		 <Tooltip
          										title="Print Template" 

          									>
												<PrintIcon style={{ color: '#5578eb',fontSize: 18
											}} onClick={()=> window.print()}/>   
										</Tooltip>
                				 	</div>
                				</div>
		        				<div className="row">
		        					{temp.templateLogoPath!=null &&
								        <div className="col-lg-6">
								                 <Figure style={{'align':'left'}}>
									              <Figure.Image
									                
									                alt="171x180"
									                src={temp.templateLogoPath}
									              />
								              
								            	</Figure>
								        </div>
								    }
								    {temp.templateImagePath!=null &&
								        <div className="col-lg-6">
								        {/*
								                 <Figure style={{'align':'right'}}>
									              <Figure.Image
									                
									                alt="171x180"
									                src={temp.templateImagePath}
									              />
								              
								            	</Figure>
								            */}
								            {this.state.templateData.formData.annotations!=null &&
								            <Annotation
										          src={temp.templateImagePath}
										          alt='Two pebbles anthropomorphized holding hands'

										          annotations={this.state.templateData.formData.annotations}

										          type={this.state.type}
										          value={this.state.annotation}
										           onChange={this.onChange}
										          onSubmit={this.onSubmit}
										          
										        />
										    }
										    {this.state.templateData.formData.annotations==null &&
										    	 <Figure style={{'align':'right'}}>
									              <Figure.Image
									                
									                alt="171x180"
									                src={temp.templateImagePath}
									              />
								              
								            	</Figure>
										    }
								
							        	</div>
							        }
							       </div>
							       </div>
							       </div>
							   </div>
			      </div>
			  
    			<form onSubmit={this.submitForm}>
    			{temp.fieldGroups != null && temp.fieldGroups.map((fieldGroup,index)=>(

	    			<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											{fieldGroup.groupName}
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
					        		
					        				<div className="row">
					        					<div className="col">
					        						{fieldGroup.fields !== null && fieldGroup.fields.map((field)=>(
					        							<>
					        							{field.dataType === "textbox" &&
					        							
						        							<TextField
									                          margin="normal"
									                          label={field.displayName}
									                          className="kt-width-full"
									                          name={field.fieldName}
									                          id={field.fieldName}
									                          //onBlur={handleBlur}
									                          onChange={this.handleChange}
															  value={this.state.templateData.formData[field.fieldName]}
									                          //value={values.firstName}
									                          //helperText={touched.firstName && errors.firstName}
									                          //error={Boolean(touched.firstName && errors.firstName)}
									                        />
								                        }
								                        {field.dataType === "wysiwyg" &&
					        												<>
						        										 <Editor
																		        editorState={this.state.editorState}
																		        wrapperClassName="demo-wrapper"
																		        editorClassName="demo-editor"
																		        toolbar={{
																		        	options: []
																		        }}
																		        
																		      />
																					
																	        </>
								                        }
								                        {field.dataType === "textarea" &&
					        							

					        							<TextField
								                          margin="normal"
								                          label={field.displayName}
								                          className="kt-width-full"
								                          name={field.fieldName}
								                          id={field.fieldName}
								                          //onBlur={handleBlur}
								                          onChange={this.handleChange}
								                          multiline="true"
								                          rows="10"
								                          rowsMax="10"
								                          value={this.state.templateData.formData[field.fieldName]}
								                          //helperText={touched.firstName && errors.firstName}
								                          //error={Boolean(touched.firstName && errors.firstName)}
								                        />
								                        }
								                         {field.dataType === "checkboxgroup" &&
					        							
					        								<FormControl component="fieldset">
														        <FormLabel component="legend">{field.displayName} {this.state.templateData.formData[field.fieldName]}</FormLabel>
														        <FormGroup>
														          {field.values.map((val)=>(
														          	<>
														          	{this.state.templateData.formData[field.fieldName] !=null && this.state.templateData.formData[field.fieldName].some(v=> v===val) &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange} value={val} name={field.fieldName} checked />}
														            label={val}
														          />
														      	  }
														      	  {this.state.templateData.formData[field.fieldName] !=null && this.state.templateData.formData[field.fieldName].some(v=> v===val)==false &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange} value={val} name={field.fieldName}  />}
														            label={val}
														          />
														      	  }
														      	  {this.state.templateData.formData[field.fieldName] ==null &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange} value={val} name={field.fieldName} />}
														            label={val}
														          />
														      	  }
														          </>
														          
														         ))}
														        </FormGroup>
														        
													      </FormControl>
								                        }
								                        {field.dataType === "checkboxgroupimage" &&
					        							
					        								<FormControl component="fieldset">
														        <FormLabel component="legend">{field.displayName} </FormLabel>
														         <div class="container" style={{'background-color':'#0B6CAF'}}>
														        {field.imagePosition === 'top' &&
														        <div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row>
														          {field.imagePath.map((val)=>(
														          		<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left':'0px'}} />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														         </div>
														    	}
														    	<div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row>
														        
														          {field.values.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
														          	<>
														          	{this.state.templateData.formData[field.fieldName] !=null && this.state.templateData.formData[field.fieldName].some(v=> v===val) &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange}  style={{'margin-left':'0px','color':'white'}} value={val} name={field.fieldName} checked />}
														            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}
														          />
														      	  }
														      	  {this.state.templateData.formData[field.fieldName] !=null && this.state.templateData.formData[field.fieldName].some(v=> v===val)==false &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange}  style={{'margin-left':'0px','color':'white'}} value={val} name={field.fieldName}  />}
														            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}
														          />
														      	  }
														      	  {this.state.templateData.formData[field.fieldName] ==null &&
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleChange} value={val}  style={{'margin-left':'0px','color':'white'}} name={field.fieldName} />}
														            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}
														          />
														      	  }
														          </>
														           </div>
														          
														         ))}
														        </FormGroup>
														         </div>
														        {field.imagePosition === 'bottom' &&
														        <div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row>
														          {field.imagePath.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left':'0px'}} />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	}

														        </div>
													      </FormControl>
								                        }
								                        {field.dataType === "checkbox" &&
					        								<>
					        								 {this.state.templateData.formData[field.fieldName] !=null &&
					        								 <FormControlLabel control={<Checkbox name={field.fieldName} checked />} label={field.displayName} />
					        								}
					        								{this.state.templateData.formData[field.fieldName] ==null &&
					        								 <FormControlLabel control={<Checkbox name={field.fieldName} />} label={field.displayName} />
					        								}
					        								</>
								                        }
								                        {field.dataType === "image" &&
								                        	
								                        	<Figure>
												              <Figure.Image
												                
												                alt="171x180"
												                src={field.displayName}
															/>
												            </Figure>
												           

								                        }
								                        </>
					        						))}
					        					</div>


					        				</div>
					        		
					        	</div>
				        	</div>
			        	</div>
		        	</div>
	        	))}
	        	
	        	</form>
	        	</>
	        	))}

	        	
	        	
    		</>
    	);
	}	
}   

export default injectIntl(withStyles(styles)(ViewTemplateData));